// Control segmentado: opciones excluyentes, como en iOS.
// La pastilla seleccionada se desliza entre opciones con un muelle sin rebote.
import { useId } from 'react';
import { motion } from 'framer-motion';

export default function Segmented<T extends string>({ value, options, onChange, label }: {
  value: T;
  options: { value: T; label: string }[];
  onChange: (v: T) => void;
  label: string;
}) {
  const id = useId();
  return (
    <div className="segmented w-full" role="group" aria-label={label}>
      {options.map((o) => {
        const active = value === o.value;
        return (
          <button
            key={o.value}
            type="button"
            className={`relative flex-1 px-3 h-9 rounded-lg text-footnote font-semibold transition-colors duration-150 ${active ? 'text-ink' : 'text-ink-2 hover:text-ink'}`}
            aria-pressed={active}
            onClick={() => onChange(o.value)}
          >
            {active && (
              <motion.span
                layoutId={`segment-${id}`}
                className="absolute inset-0 rounded-lg bg-thumb shadow-card"
                transition={{ type: 'spring', bounce: 0, duration: 0.3 }}
              />
            )}
            <span className="relative">{o.label}</span>
          </button>
        );
      })}
    </div>
  );
}
